import { AssessmentTestContextType } from '..';
import { closeOpenStepIntervals, queueForSync } from '../helpers';

export type GoToNextStepActionType = {
  type: 'GO_TO_NEXT_STEP';
  timestamp: Date;
};

export function goToNextStepReducer(
  state: AssessmentTestContextType,
  action: GoToNextStepActionType
): AssessmentTestContextType {
  if (state.screen.type !== 'STEP') {
    throw new Error('GO_TO_NEXT_STEP can only be called when in step screen');
  }
  const nextStepIndex = state.screen.stepIndex + 1;
  if (nextStepIndex >= state.steps.length) {
    throw new Error(
      'GO_TO_NEXT_STEP can only be called when not on the last step'
    );
  }

  const currentStep = state.steps[state.screen.stepIndex];
  const nextStep = state.steps[nextStepIndex];
  return {
    ...state,
    ...queueForSync(state),
    steps: state.steps.map((s) =>
      s.id === currentStep.id
        ? closeOpenStepIntervals({ step: s, timestamp: action.timestamp })
        : s
    ),
    screen: {
      type: 'STEP',
      stepId: nextStep.id,
      sectionId: null,
      stepIndex: nextStepIndex,
    },
  };
}
